import { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { Card, CardContent } from '@/components/ui/card'

interface KPICardProps {
  title: string
  value: string | number
  icon: ReactNode
  subtitle?: string
  trend?: {
    value: string
    isPositive: boolean
  }
  colorClass?: string
  loading?: boolean
}

export default function KPICard({
  title,
  value,
  icon,
  subtitle,
  trend,
  colorClass = 'text-green-600',
  loading = false
}: KPICardProps) {
  return (
    <Card className="backdrop-blur-xl hover:shadow-xl transition-all duration-300 hover:scale-105">
      <CardContent className="p-6">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <p className="text-sm font-medium text-muted-foreground mb-1">{title}</p>
            {loading ? (
              <div className="h-8 w-24 bg-muted animate-pulse rounded-md mt-2" />
            ) : (
              <p className={cn('text-3xl font-bold mt-2', colorClass)}>
                {value}
              </p>
            )}
            {subtitle && (
              <p className="text-xs text-muted-foreground mt-2">{subtitle}</p>
            )}
            {trend && (
              <div className="flex items-center mt-2 space-x-1">
                <span
                  className={cn(
                    'text-xs font-medium',
                    trend.isPositive ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'
                  )}
                >
                  {trend.isPositive ? '↑' : '↓'} {trend.value}
                </span>
              </div>
            )}
          </div>
          <div
            className={cn(
              'p-3 rounded-xl',
              colorClass.replace('text-', 'bg-').replace('-600', '-50')
            )}
          >
            {icon}
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
